import { BrandedHeader as MxBrandedHeader } from '@repo/ui/BrandedHeader';
import { BrandedHeader as LegacyBrandedHeader } from '@repo/pdx-ui/BrandedHeader';
import { useIsMobile } from '@repo/dom/hooks/useMediaQuery';
import { useRetailerSettings } from '../../hooks/useRetailerSettings';
import { useMxEnabled } from '../../hooks/useMxEnabled';

export const BrandedHeader = () => {
  const { features } = useRetailerSettings();
  const isMobile = useIsMobile();
  const mxEnabled = useMxEnabled();

  if (mxEnabled) {
    const header = features?.header;
    if (!header) return null;

    return (
      <MxBrandedHeader
        header={header}
        device={isMobile ? 'mobile' : 'desktop'}
      />
    );
  }

  return (
    <LegacyBrandedHeader
      headerHtml={features?.headerHtml ?? null}
      isMobile={isMobile}
    />
  );
};
